import "./navbar.css";
import resume from "../assets/resume.pdf";
import logo2 from "../assets/img/logo2.png";

import * as bootstrap from "bootstrap";
import useScrollDirection from "../custom hooks/useScrollDirection";

import Fade from "react-reveal/Fade";
const Navbar = () => {
  const scrollDirection = useScrollDirection();
  const offcanvasToggleHandler = (e) => {
    // handling the offcanvas toggling
    const myOffcanvas = document.getElementById("offcanvasNavbar");
    const bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
    e.preventDefault();
    e.stopPropagation();
    bsOffcanvas.toggle();
  };

  return (
    <nav
      className={`navbar navbar-expand-md  shadow-sm  nav ${
        scrollDirection === "down" ? "nav-hide" : "nav-show"
      } `} //fixed top
    >
      <div className="container-fluid">
        <a className="navbar-brand " href="/#introduction">
          <img className="navbar-brand_logo" src={logo2} alt="" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          onClick={offcanvasToggleHandler}
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
        >
          <div className="offcanvas-header">
            <button
              type="button"
              className="btn-close float-end "
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <Fade top>
              <ul
                className={`navbar-nav justify-content-end flex-grow-1 pe-3 font-family-class`}
              >
                <li className="nav-item" data-bs-dismiss="offcanvas">
                  <a
                    className="nav-link active color-secondary   navbar-link"
                    aria-current="page"
                    href="/#about"
                  >
                    <span className="color-primary">01. </span> About
                  </a>
                </li>
                <li className="nav-item" data-bs-dismiss="offcanvas">
                  <a
                    className="nav-link color-secondary  navbar-link"
                    href="/#services"
                  >
                    <span className="color-primary">02. </span> Services
                  </a>
                </li>
                <li className="nav-item" data-bs-dismiss="offcanvas">
                  <a
                    className="nav-link color-secondary  navbar-link"
                    href="/#work"
                  >
                    <span className="color-primary">03. </span> Work
                  </a>
                </li>
                <li className="nav-item" data-bs-dismiss="offcanvas">
                  <a
                    className="nav-link color-secondary  navbar-link"
                    href="/#contact"
                  >
                    <span className="color-primary">04. </span> Contact
                  </a>
                </li>
                <li className="nav-item" data-bs-dismiss="offcanvas">
                  <button className="portfolio-button m-0 ms-3 ">
                    <a
                      className="color-primary text-decoration-none"
                      href={resume}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Resume
                    </a>
                  </button>
                </li>
              </ul>
            </Fade>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
